module.exports = __webpack_public_path__ + "static/eat-dont-eat-2a7cbf5c7cab22c3e072edcbaa286aee.gif";